$(function(){   
          
   $('form.cart').on( 'click', '.quantity-plus, .quantity-minus', function() {

   // Get current quantity values
   var qty = $( this ).closest( 'form.cart' ).find( '.qty' );
   var val   = parseFloat(qty.val());
   var max = parseFloat(qty.attr( 'max' ));
   var min = parseFloat(qty.attr( 'min' ));
   var step = parseFloat(qty.attr( 'step' ));

   // Change the value if plus or minus
   if ( $( this ).is( '.quantity-plus' ) ) {
      if ( max && ( max <= val ) ) {
         qty.val( max );
      } 
   else {
      qty.val( val + step );
        }
   } 
   else {
      if ( min && ( min >= val ) ) {
         qty.val( min );
      } 
      else if ( val > 1 ) {
         qty.val( val - step );
      }
   }
    
});
 
});
jQuery('.gallery__main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    fade: true,
    swipe:true,
    swipeToSlide: true,
    infinite: true,
    adaptiveHeight:true,
    customPaging: function() { 
      return '<div class="dot"></div>';
  },
  });
  // 1- Get window width 
let windowWidth = $(window).width();

// 2- For all devices under or at 768px, use horizontal orientation
if(windowWidth > 1025) {

    jQuery('.gallery__thumbnails').slick({
        dots:false,
        arrows:false,
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.gallery__main',
        focusOnSelect: true,
        infinite: true,
        vertical:true,
        verticalSwiping: true,
        swipeToSlide: true,
        touchMove: true,
        swipe:true,        
      });
      jQuery('.gallery__main').slick({
        asNavFor: '.gallery__thumbnails',
        dots:false,
    });
}

jQuery('.gallery__main').slickLightbox({
    src: 'src',
    itemSelector: 'img.item ',
    slick:{
      prevArrow:'<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></button>',
      nextArrow:'<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
    },
  });

 